import {
  CHANGE_SELECTED_FEATURE
} from './actions'

// featureList: [
//   {/* type: 'chat', label:'Chat síncrono', description:'Toda a cadeia de negociação é feita através da nossa plataforma, desde a mensagem inicial até a inserção.'},
//   {type: 'history', label:'Histórico Completo', description:'Toda a cadeia de negociação é feita através da nossa plataforma, desde a mensagem inicial até a inserção.'}
// ]

export default function(state = {
	selectedFeature: {},
	featureList: [
    {title: "funcionalidade", type: 'chat', label:'Chat síncrono', description:'Em uma negociação é imprescindível ouvir e ser ouvido. O Com Acordo possui um chat síncrono, que permite que cada parte tenha seu momento de fala.'},
		{title: "funcionalidade", type: 'history', label:'Histórico completo', description:'Medo de perder os registros de suas negociações? No Com Acordo todo o histórico das negociações fica armazenado e acessível somente pelas partes.'},
    {title: "funcionalidade", type: 'contact', label:'Comunique-se da sua forma', description:'Cada resolução é feita de forma única. O Com Acordo permite o contato direto entre as partes para que você negocie da sua própria forma.'}
	]
}, action) {
  switch(action.type) {
    case CHANGE_SELECTED_FEATURE:
      return { ...state, selectedFeature: action.payload }
    default:
      return state
  }
}
